
/* QUOTATION */
export const GET_QUOTATION_LISTING = "GET_QUOTATION_LISTING";
export const GET_QUOTATION_LISTING_SUCCESS = "GET_QUOTATION_LISTING_SUCCESS";
export const GET_QUOTATION_LISTING_FAIL = "GET_QUOTATION_LISTING_FAIL";

export const GET_QUOTATION_FILTERS = "GET_QUOTATION_FILTERS";
export const GET_QUOTATION_FILTERS_SUCCESS = "GET_QUOTATION_FILTERS_SUCCESS";
export const GET_QUOTATION_FILTERS_FAIL = "GET_QUOTATION_FILTERS_FAIL";

export const GET_QUOTATION_DETAILS = "GET_QUOTATION_DETAILS";
export const GET_QUOTATION_DETAILS_SUCCESS = "GET_QUOTATION_DETAILS_SUCCESS";
export const GET_QUOTATION_DETAILS_FAIL = "GET_QUOTATION_DETAILS_FAIL";

export const CREATE_QUOTATION = "CREATE_QUOTATION";
export const CREATE_QUOTATION_SUCCESS = "CREATE_QUOTATION_SUCCESS";
export const CREATE_QUOTATION_FAIL = "CREATE_QUOTATION_FAIL";

export const UPDATE_QUOTATION = "UPDATE_QUOTATION";
export const UPDATE_QUOTATION_SUCCESS = "UPDATE_QUOTATION_SUCCESS";
export const UPDATE_QUOTATION_FAIL = "UPDATE_QUOTATION_FAIL";

export const DELETE_QUOTATION = "DELETE_QUOTATION";
export const DELETE_QUOTATION_SUCCESS = "DELETE_QUOTATION_SUCCESS";
export const DELETE_QUOTATION_FAIL = "DELETE_QUOTATION_FAIL";

export const CALCULATE_QUOTATION = "CALCULATE_QUOTATION";
export const CALCULATE_QUOTATION_SUCCESS = "CALCULATE_QUOTATION_SUCCESS";
export const CALCULATE_QUOTATION_FAIL = "CALCULATE_QUOTATION_FAIL";

export const SEND_QUOTATION_EMAIL = "SEND_QUOTATION_EMAIL";
export const SEND_QUOTATION_EMAIL_SUCCESS = "SEND_QUOTATION_EMAIL_SUCCESS";
export const SEND_QUOTATION_EMAIL_FAIL = "SEND_QUOTATION_EMAIL_FAIL";

export const SEND_QUOTATION_WHATSAPP = "SEND_QUOTATION_WHATSAPP";
export const SEND_QUOTATION_WHATSAPP_SUCCESS = "SEND_QUOTATION_WHATSAPP_SUCCESS";
export const SEND_QUOTATION_WHATSAPP_FAIL = "SEND_QUOTATION_WHATSAPP_FAIL";

export const RESET_QUOTATION_ACTION_STATE = 'RESET_QUOTATION_ACTION_STATE';
